var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useMonitorEngineContext } from "@nibfe/mcp-monitor-sdk";
import { useRequest } from "./useRequest";
import { API_PATH, RequestStatus } from "./useRequest";
import { useState } from "@max/max";
/**
 * 处理优惠券数据
 * 过滤出 type=0 的券，并从 reduceModel 中提取所需字段
 */
export function processCouponData(rawCoupons) {
    if (!Array.isArray(rawCoupons)) {
        return [];
    }
    return rawCoupons.filter(coupon => coupon.type === 0) // 只保留 type=0 的券
        .map(coupon => {
        var _a, _b, _c;
        return ({
            applyId: coupon.applyId,
            type: coupon.type,
            name: coupon.name,
            url: coupon.url,
            money: ((_a = coupon.reduceModel) === null || _a === void 0 ? void 0 : _a.money) || '',
            useRule: ((_b = coupon.reduceModel) === null || _b === void 0 ? void 0 : _b.useRule) || '',
            desc: ((_c = coupon.reduceModel) === null || _c === void 0 ? void 0 : _c.desc) || ''
        });
    });
}
export function useCallRecords(options) {
    const ctx = useMonitorEngineContext();
    const [callRecordsData, setCallRecordsData] = useState();
    const [currentPage, setCurrentPage] = useState(1);
    const [hasNextPage, setHasNextPage] = useState(false);
    const [isLoadingMore, setIsLoadingMore] = useState(false);
    const [couponInfos, setCouponInfos] = useState([]);
    const { requestStatus, request } = useRequest(API_PATH.CALL_RECORD);
    const pageSize = options.pageSize || 10;
    // 加载第一页数据
    function loadCallRecordsData() {
        var _a, _b, _c, _d, _e, _f;
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield request({
                    activityId: options.activityId,
                    pageNo: 1,
                    pageSize
                });
                if (!Array.isArray(res === null || res === void 0 ? void 0 : res.groupInviteRecordModels)) {
                    throw new Error('获取打call记录数据失败');
                }
                if (Array.isArray(res.queryGiftCardInfoList)) {
                    const cardInfoList = [];
                    res.queryGiftCardInfoList.forEach((item) => {
                        const applyInfoList = item.applyInfoList || [];
                        const processedData = processCouponData(applyInfoList);
                        cardInfoList.push(...processedData);
                    });
                    setCouponInfos(cardInfoList);
                }
                setCallRecordsData(res);
                setCurrentPage(1);
                setHasNextPage(res.hasNextPage || false);
                (_b = (_a = ctx._raptorReport).monitorReportBizSuccess) === null || _b === void 0 ? void 0 : _b.call(_a, {
                    apiPath: API_PATH.CALL_RECORD
                });
            }
            catch (error) {
                (_d = (_c = ctx._raptorReport).monitorReportBizFailed) === null || _d === void 0 ? void 0 : _d.call(_c, {
                    apiPath: API_PATH.CALL_RECORD
                });
                (_f = (_e = ctx._raptorReport).monitorReportLog) === null || _f === void 0 ? void 0 : _f.call(_e, error.message, error, {
                    category: 'ajaxError',
                    level: 'error'
                });
            }
        });
    }
    // 加载更多数据
    function loadMoreCallRecords() {
        var _a, _b, _c, _d, _e, _f;
        return __awaiter(this, void 0, void 0, function* () {
            if (!hasNextPage || isLoadingMore || requestStatus === RequestStatus.LOADING) {
                return;
            }
            setIsLoadingMore(true);
            const nextPage = currentPage + 1;
            try {
                const res = yield request({
                    activityId: options.activityId,
                    pageNo: nextPage,
                    pageSize
                });
                if (!Array.isArray(res === null || res === void 0 ? void 0 : res.groupInviteRecordModels)) {
                    throw new Error('获取打call记录数据失败');
                }
                // 合并数据
                setCallRecordsData(prevData => {
                    if (!prevData)
                        return res;
                    return Object.assign(Object.assign({}, res), { groupInviteRecordModels: prevData.groupInviteRecordModels.map((prevGroup, index) => {
                            const newGroup = res.groupInviteRecordModels[index];
                            if (newGroup) {
                                return Object.assign(Object.assign({}, newGroup), { inviteRecordModels: [...prevGroup.inviteRecordModels, ...newGroup.inviteRecordModels] });
                            }
                            return prevGroup;
                        }) });
                });
                setCurrentPage(nextPage);
                setHasNextPage(res.hasNextPage || false);
                (_b = (_a = ctx._raptorReport).monitorReportBizSuccess) === null || _b === void 0 ? void 0 : _b.call(_a, {
                    apiPath: API_PATH.CALL_RECORD
                });
            }
            catch (error) {
                (_d = (_c = ctx._raptorReport).monitorReportBizFailed) === null || _d === void 0 ? void 0 : _d.call(_c, {
                    apiPath: API_PATH.CALL_RECORD
                });
                (_f = (_e = ctx._raptorReport).monitorReportLog) === null || _f === void 0 ? void 0 : _f.call(_e, error.message, error, {
                    category: 'ajaxError',
                    level: 'error'
                });
            }
            finally {
                setIsLoadingMore(false);
            }
        });
    }
    // 重置数据并重新加载第一页
    function refreshCallRecords() {
        return __awaiter(this, void 0, void 0, function* () {
            setCallRecordsData(undefined);
            setCurrentPage(1);
            setHasNextPage(false);
            yield loadCallRecordsData();
        });
    }
    return {
        loadCallRecordsData,
        loadMoreCallRecords,
        refreshCallRecords,
        requestStatus,
        callRecordsData,
        hasNextPage,
        isLoadingMore,
        currentPage,
        couponInfos
    };
}
